import React from 'react'

export default function SplitViewReaderContent({ children }) {
    return (
        <div className={'ui-sv-content-reader'}>
            {children}
        </div>
    )
}
